export const SERVER_ERROR = 'SERVER_ERROR'
export const APP_ERROR = 'APP_ERROR'
export const NETWORK_ERROR = 'NETWORK_ERROR'
export const HIDE_ERROR = 'HIDE_ERROR'
export const HIDE_ALL_ERRORS = 'HIDE_ALL_ERRORS'
export const API_LOADING = 'API_LOADING'
export const API_ERROR = 'API_ERROR'
export const API_SUCCESS = 'API_SUCCESS'
export const API_CLEAR = 'API_CLEAR'

export const STATE_TYPES = {
  LOADING: 'loading',
  ERROR: 'error',
  RESULT: 'result',
  LAST_SUCCESSFUL_RESULT: 'lastSuccessfulResult',
}

const isLocalAuth =
  process.env.REACT_APP_BASE_URL_GATEWAY?.includes('localhost')

export const SERVICES_GROUPS_MAP = {
  auth: isLocalAuth ? '' : 'login-register',
  users: isLocalAuth ? '' : 'login-register',
  dzero: 83,
  farms: 84,
  retiros: 84,
  batches: 85,
  domains: 86,
  protocols: 89,
  iatf: 90,
  reports: 'export',
}

export const SERVICES_PORTS_MAP = {
  auth: 81,
  users: 81,
  dzero: 83,
  farms: 84,
  retiros: 84,
  batches: 85,
  domains: 86,
  protocols: 89,
  iatf: 90,
  reports: 94,
}
